<template>
  <div v-if="!window.PHP.bot">
    <div v-if="limitedTimeBonusesToShow && limitedTimeBonusesToShow.length > 0" class="my-6"
         :class="{ 'mt-0 mb-6 border-t pt-6 border-zt-light xl:pt-[25px] xl:mb-8' : isPhp === 'true' && location !== 'sidebar', 'border-b pb-6 xl:pb-8' : showBottomBorder === '1' }">
      <div class="text-[20px] font-semibold leading-7 ml-2 line-clamp-2 flex justify-between items-center mr-2 xl:mr-0 xl:mx-0" :class="{ 'mr-100' : location !== 'football' }">
        Aktywne bonusy z limitem czasowym:
        <div v-if="location === 'football'" class="font-normal text-base flex flex-row">
          <button class="swiper-okazjonalne-navigation-left w-6 h-6 bg-zt-light-bg rounded-zt border border-zt-light
                   text-white mr-2 zt-hover shrink-0">
            &lt;
          </button>
          <button class="swiper-okazjonalne-navigation-right w-6 h-6 bg-zt-light-bg rounded-zt border border-zt-light
                   text-white zt-hover shrink-0">
            &gt;
          </button>
        </div>
      </div>
      <div v-if="location === 'football'" class="pt-5">
        <div id="limited-time-bonus-swiper" class="swiper pl-2 xl:pl-0">
          <div class="swiper-wrapper flex xl:gap-x-px">
            <a :href="bonus.limited_time_bonus.post_link" v-for="bonus in limitedTimeBonusesToShow"
               data-count-click="Bonusy okazjonalne w Nowej PN"
               class="no-default-style swiper-slide flex flex-row gap-x-2 w-4/5 cursor-pointer group xl:w-fit">
              <img :src="`/wp-content/themes/zawodtyper/assets/images/bukmacherzy/${ bonus.limited_time_bonus.bookmaker_name.toLowerCase() }.svg`"
                   class="object-cover group-hover:brightness-90 group-active:brightness-75 rounded-zt" :alt="bonus.limited_time_bonus.bookmaker_name"
                   width="140" height="79"/>
              <div class="flex flex-col gap-y-[5px]">
                <p class="line-clamp-3 group-hover:brightness-90 group-active:brightness-75 text-sm font-semibold leading-[21px] pr-2">
                  {{bonus.limited_time_bonus.bonus_name}}
                </p>
                <div class="flex flex-row gap-x-1">
                  <img width="9" height="12" :src="'/wp-content/themes/zawodtyper/assets/images/klepsydra.svg'" alt="">
                  <div class="text-xs leading-[12px]" v-html="formatDate(bonus)"></div>
                </div>
              </div>
            </a>
          </div>
        </div>
      </div>
      <div v-else-if="location === 'sidebar'" class="flex flex-col gap-y-[19px] pt-[17px]">
        <a :href="bonus.limited_time_bonus.post_link" v-for="bonus in limitedTimeBonusesToShow"
           data-count-click="Sidebar Nowa PN - OKAZJONALNE (nowe umiejscowienie)"
           data-count-click-category="football"
           class="no-default-style swiper-slide flex flex-row gap-x-2 cursor-pointer group xl:w-full">
          <img :src="`/wp-content/themes/zawodtyper/assets/images/bukmacherzy/${ bonus.limited_time_bonus.bookmaker_name.toLowerCase() }.svg`"
               class="object-cover group-hover:brightness-90 group-active:brightness-75 rounded-zt" :alt="bonus.limited_time_bonus.bookmaker_name"
               width="140" height="79"/>
          <div class="flex flex-col gap-y-[5px]">
            <p class="line-clamp-3 group-hover:brightness-90 group-active:brightness-75 text-sm font-semibold leading-[21px] pr-2">
              {{bonus.limited_time_bonus.bonus_name}}
            </p>
            <div class="flex flex-row gap-x-1">
              <img width="9" height="12" :src="'/wp-content/themes/zawodtyper/assets/images/klepsydra.svg'" alt="">
              <div class="text-xs leading-[12px]" v-html="formatDate(bonus)"></div>
            </div>
          </div>
        </a>
      </div>
      <div v-else class="flex flex-col pt-3 gap-y-4" :class="{ 'gap-y-6' : isPhp === 'true' }">
        <LimitedTimeBonus v-for="bonus in limitedTimeBonusesToShow" :analytic="isPhp === 'true' ? 'NP' : ''"
                          :key="bonus.limited_time_bonus.bonus_name + '_' + bonus.limited_time_bonus.bookmaker_name"
                          :data="bonus" :isTdPost="true" />
      </div>
    </div>
  </div>
</template>

<script>
import LimitedTimeBonus from '../without_deposit/LimitedTimeBonus.vue';
import {DateTime} from "luxon";
import Swiper from "swiper";
import {Navigation} from "swiper/modules";

export default {
  name: 'LimitedTimeBonuses',
  components: { LimitedTimeBonus },
  props: {
    data: Object,
    isTd: Boolean,
	  isPhp: String,
    location: String,
	  showBottomBorder: {
			type: String,
		  default: '0'
	  }
  },
	data: () => ({
		limitedTimeBonuses: [],
    swiper: {}
	}),
	mounted() {
		if (this.isPhp === 'true') {
      this.loadBonuses();
		}
	},
	computed: {
    limitedTimeBonusesToShow() {
      if (this.location === 'sidebar') {
        return this.limitedTimeBonuses.slice(0, 3);
      }
			if (this.isPhp === 'true') {
				return this.limitedTimeBonuses;
			}
      return this.isTd ? this.data : this.data.limitedTimeBonuses;
    }
  },
	methods: {
    mountSwiper() {
      this.swiper = new Swiper('#limited-time-bonus-swiper', {
        modules: [Navigation],
        slidesPerView: window.size.mobile ? 'auto' : 2,
        init: true,
        grabCursor: true,
        navigation: {
          nextEl: '.swiper-okazjonalne-navigation-right',
          prevEl: '.swiper-okazjonalne-navigation-left',
          disabledClass: 'opacity-50',
        },
        spaceBetween: window.size.mobile ? 20 : 0
      });
    },
    formatDate(bonus) {
      const phrase = `<span class="text-zt-more font-medium">${window.size.mobile ? 'Do końca' : 'Zostało'}</span>`;
      const endTime = DateTime.fromSQL(bonus.limited_time_bonus.bonus_end_time);
      const now = DateTime.now();
      const diff = endTime.diff(now, ['days' ,'hours', 'minutes']).toObject();
      if (diff.days >= 1) {
        return `${ phrase }:  <span class="text-[#CE2121] font-bold">${ diff.days } ${diff.days > 1 ? 'dni' : 'dzień'}</span>`;
      } else if (diff.hours >= 1) {
        return `${ phrase }:  <span class="text-[#CE2121] font-bold">${ diff.hours } godz. </span>`;
      } else if (diff.minutes >= 1) {
        return `${ phrase }: <span class="text-[#CE2121] font-bold">${ Math.round(diff.minutes) } min.</span>`;
      } else {
        return `<span class="text-zt-more font-medium">Zakończono</span>`;
      }
    },
		loadBonuses() {
			axios.get('/wp-json/acf/v3/options/options?_fields=acf.limited_time_bonuses&acf_format=standard').then(response => {
				this.limitedTimeBonuses = response.data.acf.limited_time_bonuses;
				if (this.limitedTimeBonuses.length > 0) {
					this.limitedTimeBonuses.sort((a, b) => {
						const endA = DateTime.fromSQL(a.limited_time_bonus.bonus_end_time).toMillis();
						const endB = DateTime.fromSQL(b.limited_time_bonus.bonus_end_time).toMillis();
						if (endA < Date.now() && endB < Date.now()) {
							return 0;
						} else if (endA < Date.now()) {
							return 1;
						} else if (endB < Date.now()) {
							return -1;
						}
						return endA - endB;
					});
					this.limitedTimeBonuses = this.limitedTimeBonuses.filter(a => {
						const endDateTime = DateTime.fromSQL(a.limited_time_bonus.bonus_end_time).toMillis();
						const threeHoursAgoMillis = DateTime.now().toMillis() - 3 * 60 * 60 * 1000;
						return endDateTime > threeHoursAgoMillis;
					});
				}
        if (this.location === 'football') {
          setTimeout(() => {
            this.mountSwiper();
          }, 0);
        }
			});
		}
	}
};
</script>